import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { SystemLayout } from "../types";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const ReactQuery: React.FC<SystemLayout> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};

export default ReactQuery;
